module.exports = __webpack_public_path__ + "assets/gpt-black.89424aa6.svg";